import { typeScale } from '@/theme/tokens';
import { Stack } from '@/ui/layout/Stack';
import { Box } from '@/ui/primitives/Box';
import { Text } from '@/ui/primitives/Text';
import type { ReactElement } from 'react';

type FlowQaBrandLockupProps = {
  logoSize?: string;
};

export const FlowQaBrandLockup = ({ logoSize = '40px' }: FlowQaBrandLockupProps): ReactElement => (
  <Stack direction="row" gap="sm" alignItems="center">
    <Box
      component="img"
      src="/logo.png"
      alt=""
      aria-hidden
      sx={{ display: 'block', height: logoSize, width: logoSize }}
    />
    <Text role="sectionTitle" sx={{ fontSize: `${typeScale.xl}px` }}>
      FlowQA
    </Text>
  </Stack>
);
